module.exports = __webpack_public_path__ + "img/_forward.aad7a88a.svg";